/**
 * Unlike the duplicate rejection, this answer names the field it concerns and not the position
 * inside it, so a batch cannot be told which of its names was refused.
 */
export class SettingsValidationError extends Error {
  readonly messages: readonly string[];

  constructor(messages: readonly string[]) {
    super(messages.join(' '));
    this.name = 'SettingsValidationError';
    this.messages = messages;
  }
}

export function toSettingsValidationMessages(error: unknown): readonly string[] {
  return error instanceof SettingsValidationError ? error.messages : [];
}
